import { IBasicVolunteerResponse, IGetVolunteerByIdResponse } from '@joc/api-gateway';
import { API } from 'core/API';

export const getInitialValues = (volunteerData: IBasicVolunteerResponse) => {
	const initialValues = {
		...volunteerData,
		email: volunteerData.email || '',
		gender: volunteerData.gender?.id,
		gradeId: volunteerData.volunteerSchoolsGrades?.at(0)?.gradeId,
		password: '',
		defaultOrganizationId: volunteerData.defaultOrganizationId,
	};
	return initialValues;
};

export const getSchoolGrades = async (volunteer: IGetVolunteerByIdResponse) => {
	const organizationId = ((volunteer as any).organizations || [])?.find(
		(organization: { schoolId?: number }) => organization.schoolId
	)?.id;
	if (!organizationId) {
		return undefined;
	}
	const organization = await API.getOrganisationById(Number(organizationId), true);
	return organization.school?.grades;
};
